// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#img-hover[data-v-6f6eff7a] {\n  opacity: 0.55;\n  transition: all 0.3s ease-in-out;\n}\n#hover-parent:hover > #img-hover[data-v-6f6eff7a] {\n  opacity: 1;\n}\n.border-primary #img-hover[data-v-6f6eff7a] {\n  opacity: 1;\n}\n#img-mobile[data-v-6f6eff7a] {\n  opacity: 0.1;\n  transition: all 0.3s ease-in-out;\n}\n#mobile-parent:hover > #img-mobile[data-v-6f6eff7a] {\n  opacity: 1;\n}\n.border-primary #img-mobile[data-v-6f6eff7a] {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
